module.exports = {
          srcSet: __webpack_public_path__ + "39a299bd0b65ff28e56d22a7078457a7-65.png"+" 65w",
          images:[ {path: __webpack_public_path__ + "39a299bd0b65ff28e56d22a7078457a7-65.png",width: 65,height: 65}],
          src: __webpack_public_path__ + "39a299bd0b65ff28e56d22a7078457a7-65.png",
          toString:function(){return __webpack_public_path__ + "39a299bd0b65ff28e56d22a7078457a7-65.png"},
          
          width: 65,
          height: 65
        }